import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";

export const columnsAverages = (trash, isCompleted) => [
    {
        Header: "Height",
        accessor: "height",
    },
    {
        Header: "Width",
        accessor: "width",
    },
    {
        Header: "Depth",
        accessor: "depth",
    },
    {
        Header: "Weight",
        accessor: "weight",
    },
    {
        Header: "Position",
        accessor: "position",
    },
    {
        Header: "",
        accessor: "key",
        Cell: (row) => {
            return (
                <div className="icon-group">
                    {!isCompleted && row.original.positionValue !== "standard" && (
                        <button onClick={(e) => trash(row.original.positionValue)}>
                            <FontAwesomeIcon icon={faTrash} />
                        </button>
                    )}
                </div>
            );
        },
    },
];

export const INITIAL_STATE = {
    measurements: [],
    measuringWipKey: null,
    positionList: {
        active: [],
        available: [],
        all: [],
    },
    currentPosition: null,
    fullPositionList: [],
    attributes: {
        data: {},
    },
    uomValues: [],
    isDigitalLite: false,
    isCompleted: false,
    invalidMeasurements: [],
};

export const uom = {
    Imperial: [{ value: "in", text: "in" }],
    Metric: [
        { value: "mm", text: "mm" },
        { value: "cm", text: "cm" },
        { value: "dmt", text: "dmt" },
        { value: "lmt", text: "lmt" },
        { value: "mt", text: "mt" },
    ],
};

export const uom_Inner = {
    Imperial: [{ value: "in", text: "in" }],
    Metric: [
        { value: "mm", text: "mm" },
        { value: "cm", text: "cm" },
    ],
};

export const getUomList = (position) => {
    switch (position.toLowerCase()) {
        case "inner_pack":
        case "inner-inner_pack":
            return uom_Inner;
        default:
            return uom;
    }
};

export const uomWeight = {
    Imperial: [
        { value: "lb", text: "lb" },
        { value: "oz", text: "oz" },
    ],
    Metric: [
        { value: "kg", text: "kg" },
        { value: "g", text: "g" },
        { value: "mg", text: "mg" },
        { value: "dg", text: "dg" },
        { value: "mcg", text: "mcg" },
        { value: "tne", text: "tne" },
    ],
};

export const uomWeight_Inner = {
    Imperial: [
        { value: "lb", text: "lb" },
        { value: "oz", text: "oz" },
    ],
    Metric: [{ value: "g", text: "g" }],
};

export const getUomWeightList = (position) => {
    switch (position.toLowerCase()) {
        case "inner_pack":
        case "inner-inner_pack":
            return uomWeight_Inner;
        default:
            return uomWeight;
    }
};

export const newAverage = (position) => {
    return {
        position: position.text,
        positionValue: position.value,
        fullPosition: position,
        depth: 0,
        height: 0,
        width: 0,
        weight: 0,
    };
};

export const DEBOUNCE_DELAY = 800;

export const DEFAULT_POSITION_VALUE = "standard";

export const CUBISCAN_DEFAULT_UOM = {
    Metric: {
        height: "cm",
        width: "cm",
        depth: "cm",
        weight: "kg",
    },
    Imperial: {
        height: "in",
        width: "in",
        depth: "in",
        weight: "lb",
    },
};
export const NO_FOCUS_STEAL_ELEMENT_NAME_LIST = ["height", "width", "depth", "weight", "heightUom", "widthUom", "depthUom", "weightUom"];
